<template>
  <v-row align="center" justify="center" class="login-page mx-2">
    <!-- 시스템 점검 안내 팝업 -->
    <v-dialog v-model="showNotice" persistent max-width="600px">
      <v-card class="login-notice-card pa-7" style="position: relative;">
        <v-btn
          icon
          small
          class="login-notice-close"
          @click="showNotice = false"
        >
          <v-icon color="#777">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="text-center pa-0">
          <div class="login-notice-title">📢 시스템 점검 안내</div>
          <div class="login-notice-subtitle">
            안정적인 서비스 제공을 위해 <br />
            아래 시간 동안 시스템 점검이 진행될 예정입니다.
          </div>

          <div class="login-notice-badge my-5">
            2026.10.20(화) 07:00 ~
          </div>

          <div class="login-notice-body">
            점검 시간 동안<br />
            <strong> 지원서 작성, 조회 및 서비스 접속이 제한 </strong>
            됩니다.<br />
            빠른 시간 내 서비스를 제공할 수 있도록 하겠습니다.
          </div>
          <p class="login-notice-footnote">
            ※ 진행 시간은 시스템 상황에 따라 예정보다 앞당겨지거나 지연될 수 있습니다. <!-- eslint-disable-line -->
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- // 시스템 점검 안내 팝업 -->
    <v-card width="100%" class="text-xs-center elevation-12" max-width="550px">
      <v-row justify="center" class="ma-0">
        <v-col class="pa-0 text-left login-title">{{ $t('로그인') }}</v-col>
      </v-row>
      <v-row align="center" justify="center" class="ma-0">
        <v-col class="text-center py-0 mb-10" style="padding: 0 75px;">
          <v-form ref="form">
            <i-text-field
              v-model="email"
              :prepend-inner-icon="mdiAccount"
              :error-messages="emailErrors"
              label="이메일을 입력해주세요."
              :rules="[rules.required]"
              single-line
              required
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              outlined
              dense
            ></i-text-field>
            <i-text-field
              v-model="password"
              :prepend-inner-icon="mdiKey"
              :append-icon="show2 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
              ]"
              :type="show2 ? 'text' : 'password'"
              label="비밀번호를 입력해주세요"
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show2 = !show2"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              outlined
              dense
              @keyup.enter="surffyAction"
            ></i-text-field>

            <div class="mb-5 text-right">
              <a @click="goChangePW" class="link">{{
                $t('비밀번호 재설정')
              }}</a>
            </div>
            <i-btn color="primary" block depressed @click="surffyAction">
              로그인
            </i-btn>
          </v-form>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="ma-0 px-6 py-4" align="center" justify="space-between">
        <v-col cols="auto" class="pa-0">
          <v-subheader class="pa-0">{{
            $t('회원이 아니라면 가입하세요.')
          }}</v-subheader>
        </v-col>
        <v-col cols="auto" class="pa-0">
          <i-btn color="primary" @click="goSignupPage" depressed>
            회원가입
          </i-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { validateEmail } from '@/utils/validation';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';
import { postForm, getEncryption } from '@/api/network';
import { mdiAccount, mdiKey, mdiEye, mdiEyeOff } from '@mdi/js';
import { surffyProxy } from '@/utils/surffy';
import RSAKey from '@/utils/rsa/rsa.js';

export default {
  mixins: [validationMixin, LoadingMixin, DialogMixin],
  validations: {
    password: { required },
    email: { required, email },
  },

  data() {
    return {
      mdiAccount,
      mdiKey,
      mdiEye,
      mdiEyeOff,
      email: '',
      password: '',
      logMessage: '',
      invalid: true,
      show1: false,
      show2: false,
      showNotice: false, // <!-- 시스템 점검 안내 팝업 -->
      rules: {
        required: value => !!value || '필수입력 사항입니다.',
        min: v => v.length >= 8 || '최소 8자 이상 입력하셔야합니다.',
        char: v =>
          /(?=.*[a-zA-Z])/.test(v) || '최소 하나의 영문자가 필요합니다.',
        number: v => /(?=.*\d)/.test(v) || '최소 하나의 숫자가 필요합니다.',
        specialChar: v =>
          /([!@#$%])/.test(v) || '최소 하나의 특수문자가 필요합니다. [!@#$%]',
      },
      encoder: null,
    };
  },
  computed: {
    isUsernameValid() {
      return validateEmail(this.email);
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('required');
      return errors;
    },
  },

  methods: {
    surffyAction() {
      this.login();
    },
    async login() {
      if (this.emailErrors.length == 0 && this.$refs.form.validate()) {
        surffyProxy(async clear => {
          this.showLoading();

          if (!this.encoder) {
            const rsa = new RSAKey();
            const {
              publicKeyModulus,
              publicKeyExponent,
              sessionKey,
            } = await getEncryption();
            rsa.setPublic(publicKeyModulus, publicKeyExponent);
            this.encoder = (email, password) => ({
              loginId: rsa.encrypt(email),
              password: rsa.encrypt(password),
              sessionKey: sessionKey,
            });
          }
          postForm(
            'api/v1/' + this.$route.params.tenantKey + '/login/certificate',
            this.encoder(this.email, this.password),
          )
            .then(response => {
              if (response && response.data && response.data.status == 'OK') {
                this.$store.commit('setToken', response.data.userToken);
                const redirectRoutePath = this.$store.getters.redirectUrl;
                if (redirectRoutePath !== '') {
                  this.$store.commit('clearRedirectUrl');
                  this.$router.push(redirectRoutePath);
                } else {
                  this.$router.push({
                    name: 'myPage',
                    params: { tenantKey: this.$route.params.tenantKey },
                  });
                }
              } else if (response.data.status == 'DORMANT') {
                this.showAlert({
                  message: response.data.message,
                  callback: this.goDormantUserClear,
                  param: this.email,
                });
              } else {
                var message = '사용자가 없거나, 인증에 실패했습니다.';
                if (response && response.data && response.data.message)
                  message = response.data.message;
                this.$showAlert({ message: message });
              }
              this.hideLoading();

              clear();
            })
            .catch(error => {
              this.$showAlert('사용자가 없거나, 인증에 실패했습니다.');
              this.hideLoading();
              this.logMessage = error.response.data;
            });
        });
      }
    },
    initForm() {
      this.email = '';
      this.password = '';
    },
    goSignupPage() {
      this.$router.push({
        name: 'signup',
        params: { tenantKey: this.$route.params.tenantKey },
      });
    },
    goChangePW() {
      this.$router.push({
        name: 'changePw',
        params: { tenantKey: this.$route.params.tenantKey },
      });
    },
    goDormantUserClear(email) {
      this.$router.push({
        name: 'dormant',
        params: { tenantKey: this.$route.params.tenantKey, email: email },
      });
    },
  },
};
</script>

<style>
/*
.v-card {
  opacity: 0.8;
}
*/
.login-error-msg {
  color: red;
}

a.link {
  color: #333;
  font-size: 14px;
  text-decoration: underline;
}

/* tablet */
@media all and (max-width: 768px) {
  .v-sheet {
    box-shadow: none !important;
  }
}

/* 김대식 css 작업구간 */

.login-page .login-title {
  padding: 80px 75px 32px 75px !important;
  font-size: 30px;
  font-weight: 700;
  color: #363c43;
}

.login-page .v-card {
  border-radius: 20px !important;
}

.login-page .v-input__slot {
  min-height: 38px !important;
}

.login-page .v-icon {
  font-size: 18px !important;
}

.login-page .v-label {
  font-size: 14px;
}

.login-page .v-subheader {
  height: auto !important;
}
.modal-wrapper {
  position: fixed;
  padding-top: 30px;

  top: 10px;
  bottom: 20px;
  right: 0;
  width: 30%; /* 모달의 너비 설정 */
  height: 100%; /* 모달의 높이 설정 */
  background-color: white;
  border: 1px solid #ccc;
  z-index: 100;
}

.modal-content {
  padding: 20px;
}

.sticky {
  position: fixed;
  top: 85%;
  right: 70%;
  opacity: 1;
  margin: 0 -580px 0 0;
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
}

/* 김대식 css 작업구간 */

/* 시스템 점검 안내 팝업 */
.login-notice-card {
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  background-color: #fffaf3;
  --title-accent: #052b57;
  --badge-accent: #2563eb;
}

.login-notice-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  background: transparent !important;
}

.login-notice-close:hover .v-icon {
  color: #000;
  transform: scale(1.05);
  transition: all 0.15s ease;
}

/* 메인 타이틀 (포인트 색상) */
.login-notice-title {
  color: var(--title-accent);
  font-weight: 800;
  font-size: 36px;
  line-height: 1.25;
  letter-spacing: -0.2px;
  margin-top: 14px;
  margin-bottom: 28px;
}

/* 부제 */
.login-notice-subtitle {
  color: #222425;
  font-size: 24px;
  line-height: 1.4;
}

/* 본문 */
.login-notice-body {
  color: #4a4a4a;
  font-size: 24px;
  line-height: 1.4;
  margin-top: 8px;
}

.login-notice-footnote {
  font-size: 15px;
  color: #777;
  margin-top: 12px;
  text-align: center;
  line-height: 1.4;
}

/* 일정 배지 (오렌지 바) */
.login-notice-badge {
  position: relative;
  display: inline-block;
  padding: 18px 30px;
  font-weight: 800;
  font-size: 28px;
  letter-spacing: 0.2px;
  color: #fff;
  border-radius: 20px;
  /* 젤리 느낌: 그라데이션 + 입체감(바깥/안쪽 그림자) */
  background: var(--badge-accent);
  background-image: linear-gradient(
    180deg,
    color-mix(in srgb, var(--badge-accent) 86%, white 14%),
    color-mix(in srgb, var(--badge-accent) 72%, black 8%)
  );
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15),
    inset 0 2px 4px rgba(255, 255, 255, 0.35),
    inset 0 -3px 6px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  backdrop-filter: saturate(120%);
}

/* 젤리 광택 하이라이트 */
.login-notice-badge::before {
  content: '';
  position: absolute;
  left: 12%;
  top: 12%;
  width: 76%;
  height: 48%;
  border-radius: 9999px;
  background: radial-gradient
    (ellipse at top left, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0) 60%);
  filter: blur(1px);
  pointer-events: none;
}
/* 시스템 점검 안내 팝업 */
</style>
